﻿import { hardwareUnitLogMessagesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { rangeFilterUTC } from "../helpers/utils";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("hardware-module-logs"),
  endpoint: "hardware-unit-log-messages",
  operations: hardwareUnitLogMessagesOps,
  roleView: [ROLE.EMZ_DEVELOPER],
  roleAdmin: [ROLE.EMZ_DEVELOPER],
  baseRoute: "hardware-module-logs",
  singularName: (t) => t("Hardware module log"),
  name: (t) => t("Hardware module logs"),

  sendCulture: true,
  initialFilter: {},
  filterFormatter: rangeFilterUTC,
  syncCustomerFilter: true,
});

export default conf;
